/*
 * @providesModule Optional
 *
 */

import * as React from 'react';

interface OptionalProps {
  // any value to check for truthy or falsy. If truthy, then the children will be rendered.
  test: any;
  // only single child are supported
  children: React.ReactNode;
}

export default function Optional(props: OptionalProps) {
  if (!props.test) {
    return null;
  }

  return <>{props.children}</>;
}
